<script setup lang="ts">

</script>

<template>
  <div class="section">
    <div v-if="$slots.header" class="header">
      <slot name="header" />
    </div>
    <slot />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.section
  @apply p-[#{$panel-p-default}] flex flex-col gap-[#{$panel-properties-gap-properties}]

  & + .section
    @apply border-t border-t-[#{$menu-b-separator}]

.header
  @apply t-[#{$global-t-default}] t-menu-lg font-medium
</style>
